import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InputEmail } from '../InputEmail';
import { HALFWIDTH_PATTERN } from '@/hooks/useShareDeviceReservationForm';

interface ReservationFormFieldsProps {
  lastName: string;
  firstName: string;
  email: string;
  onLastNameChange: (value: string) => void;
  onFirstNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  disabled?: boolean;
}

/**
 * 予約フォームの入力フィールドコンポーネント
 */
export const ReservationFormFields = ({
  lastName,
  firstName,
  email,
  onLastNameChange,
  onFirstNameChange,
  onEmailChange,
  disabled = false,
}: ReservationFormFieldsProps) => {
  const { t } = useTranslation();
  const [emailTouched, setEmailTouched] = useState(false);

  const isEmailInvalid =
    emailTouched && email.trim() !== '' && !HALFWIDTH_PATTERN.test(email);

  return (
    <div className="f3__fields">
      <div className="f3__field-group">
        <div className="f3__field">
          <div className="f3__field-name">
            {t('shareDevice.userInfo.fields.lastName')}
          </div>
          <input
            className="f3__input"
            type="text"
            name="last_name"
            placeholder={t('shareDevice.userInfo.fields.lastNamePlaceholder')}
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            disabled={disabled}
            required
          />
        </div>
        <div className="f3__field">
          <div className="f3__field-name">
            {t('shareDevice.userInfo.fields.firstName')}
          </div>
          <input
            className="f3__input"
            type="text"
            name="first_name"
            placeholder={t('shareDevice.userInfo.fields.firstNamePlaceholder')}
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            disabled={disabled}
            required
          />
        </div>
      </div>
      <div className="f3__field">
        <div className="f3__field-name">
          {t('shareDevice.userInfo.fields.email')}
        </div>
        <InputEmail
          className="f3__input"
          name="email"
          placeholder={t('shareDevice.userInfo.fields.emailPlaceholder')}
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          onBlur={() => setEmailTouched(true)}
          disabled={disabled}
          required
        />
        {isEmailInvalid && (
          <p
            className="f3__alert f3__alert--error"
            style={{ marginTop: '8px', marginBottom: '0' }}
          >
            {t('shareDevice.userInfo.validation.emailInvalid')}
          </p>
        )}
      </div>
    </div>
  );
};
